import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Button,
  Container,
  Pagination,
  Tooltip,
  Checkbox,
  Divider,
} from "@mui/material";
import SendSharpIcon from "@mui/icons-material/SendSharp";
import CommonAccordion from "../../custom-components/CommonAccordion";
import CommonDownload from "../../custom-components/CommonDownload";
import SaveAltRoundedIcon from "@mui/icons-material/SaveAltRounded";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useLocation, useNavigate } from "react-router-dom";
import CodeEditor from "./CodeEditorForAPITesting";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import CommonCopy from "../../custom-components/CommonCopy";
import { ReactComponent as GenerateButtonIcon } from "../../../images/generateButton.svg";
import { apiStepDefinitionToolCalling } from "../../../services/webServices";
import { use } from "react";

const POJOclasses = (props) => {
  const location = useLocation();
  //console.log(props, "propspropspropspropsprops");
  const navigate = useNavigate();
  const isDisabled = true;
  const [pojoClassData, setPojoClassData] = useState(props.pojoData);
  const [stepDefinitionData, setStepDefinitionData] = useState([]);
  const [downloadOpen, setDownloadOpen] = useState(false);
  const { setLoadingState } = useContext(LoadingModalContext);
  const [liked, setLiked] = useState(false);
  const [disliked, setDisliked] = useState(false);
  const [processedpojoClassData, setProcessedPojoClassData] = useState("");
  const nextButton = !!props.pojoclassesNextButton ? [props.pojoclassesNextButton] : [];

  const [activeThumb, setActiveThumb] = useState(null);
  const [isCopied, setIsCopied] = useState(false);

  const defaultExpand = Object.keys(props.pojoData).length > 0 && Object.keys(props.stepDefinitionData).length === 0;

  useEffect(() => {
    if (props.pojoData) {
      setPojoClassData(props.pojoData);
    }
  }, [props.pojoData]);


  // const handleStepDefinition = async () => {
  //   let fake;
  //   const startProgress = (setProgress) => {
  //     let progress = 0;
  //     let stop = false;
  //     let finalMessageShown = false;

  //     const interval = setInterval(() => {
  //       if (stop) return;

  //       progress += 1.5 ;
  //       if (progress >= 98 && !finalMessageShown) {
  //         finalMessageShown = true;
  //         setLoadingState((prev) => ({
  //           ...prev,
  //           message: "Almost done! Fetching your output",
  //         }));
  //       }

  //       if (progress >= 98) progress = 98;

  //       setProgress((prev) => ({
  //         ...prev,
  //         progress: Math.max(prev.progress, Math.floor(progress)),
  //       }));
  //     }, 200);

  //     return {
  //       stop: () => {
  //         stop = true;
  //         clearInterval(interval);
  //       },
  //       completeTo100: async () => {
  //         stop = true;
  //         clearInterval(interval);

  //         // Rush to 100%
  //         setProgress((prev) => ({
  //           ...prev,
  //           progress: 100,
  //         }));
  //         await new Promise((res) => setTimeout(res, 500));
  //       },
  //     };
  //   };

  //   const finishTo100AndClose = async () => {
  //     await fake.completeTo100();
  //     setLoadingState({ open: false, message: "", progress: null });
  //   };
  //   // Initial message
  //   setLoadingState({
  //     open: true,
  //     message: "Generating Step Definition",
  //     progress: 0,
  //   });

  //   fake = startProgress(setLoadingState);
  //   try {
  //     const response = await apiStepDefinitionToolCalling({
  //       featureFile: props.FeatureFile,
  //       pojoClass: pojoClassData,
  //     }, props.framework);
  //     console.log(response, "response");
  //     console.log(response.data, "response.dat");
  //     setStepDefinitionData(response.data);
  //     await finishTo100AndClose();

  //     navigate(`/dashboard/api-testing/${props.framework}/${props.projectType}`, {
  //       state: { ...location.state, stepDefinitionData: response.data },
  //     });
  //   } catch (error) {
  //     console.error("Error fetching step definition:", error);
  //     setLoadingState({ open: false, message: "", progress: null });
  //   } finally {
  //     setLoadingState({ open: false, message: "", progress: null });
  //   }
  // };
  const IconComponent = () => (
    <Box sx={{ maxWidth: 14, display: "flex", flexDirection: "column" }}>
      <img
        loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/74001bbbe35d84ed7dd44adbf23d2273b030df4d38296f54b84768e53b777ae2?placeholderIfAbsent=true&apiKey=61dcb7c26aae4febb0f66efb27027a73"
        alt=""
        style={{ width: "100%", objectFit: "contain" }}
      />
    </Box>
  );
  const handleDownloadClick = () => {
    setDownloadOpen(true);
  };

  const handleCloseDownload = () => {
    setDownloadOpen(false);
  };

  const handlePageSource = () => {
    navigate(location.pathname, {
      state: { ...location.state, pageSource: "" },
      replace: true,
    });
  };

  const handleDownload = () => { };
  const handleLike = () => {
    setLiked(!liked);
    if (disliked) setDisliked(false);
  };

  const handleDislike = () => {
    setDisliked(!disliked);
    if (liked) setLiked(false);
  };

  const handleThumbClick = (thumbType) => {
    setActiveThumb((prev) => (prev === thumbType ? null : thumbType));
  };
  useEffect(() => {
    const processed = (() => {
      try {
        if (Array.isArray(pojoClassData)) {
          return pojoClassData.map(obj => Object.values(obj).join(' ')).join('\n');
        }
        const parsed = JSON.parse(pojoClassData);
        if (Array.isArray(parsed)) {
          return parsed.map(obj => Object.values(obj).join(' ')).join('\n');
        }
        return pojoClassData; // If not an array, return as-is
      } catch (e) {
        return pojoClassData; // Fallback in case of error
      }
    })();

    setProcessedPojoClassData(processed);
  }, [pojoClassData]);




  return (
    <Box>
      <CommonAccordion
        summary={"POJO Classes"}
        details={
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: 1,
              p: 2,
              marginTop: "-15px",
            }}
          >
            <CodeEditor
              codeContent={
                (() => {
                  try {
                    // If it's an array, join values
                    if (Array.isArray(pojoClassData)) {
                      return pojoClassData.map(obj => Object.values(obj).join(' ')).join('\n');
                    }

                    // Try to parse string (if it was stored as JSON)
                    const parsed = JSON.parse(pojoClassData);
                    if (Array.isArray(parsed)) {
                      return parsed.map(obj => Object.values(obj).join(' ')).join('\n');
                    }

                    // If not parsable or not an array, return as-is
                    return pojoClassData;
                  } catch (e) {
                    return pojoClassData; // fallback in case of error
                  }
                })()}
              setCodeContent={setPojoClassData}
            />

            <Container maxWidth={false} disableGutters>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                justifyContent="flex-start"
                maxWidth="557px"
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 2,
                    marginTop: 2,
                  }}
                >
                  <Tooltip title="Like" arrow>
                    <Box
                      onClick={() => handleThumbClick("like")}
                      sx={{
                        cursor: "pointer",
                        marginRight: 2, // Margin between the buttons
                        "&:hover": {
                          color: "#49A3FF", // Change color on hover
                        },
                      }}
                    >
                      {activeThumb === "like" ? (
                        <ThumbUpIcon sx={{ fontSize: "24px" }} /> // Filled thumbs up when clicked
                      ) : (
                        <ThumbUpOutlinedIcon sx={{ fontSize: "24px" }} /> // Outlined thumbs up by default
                      )}
                    </Box>
                  </Tooltip>

                  {/* Thumbs Down Button with Tooltip */}
                  <Tooltip title="Dislike" arrow>
                    <Box
                      onClick={() => handleThumbClick("dislike")}
                      sx={{
                        cursor: "pointer",
                        marginRight: 2, // Margin between the buttons
                        "&:hover": {
                          color: "#FF4842", // Change color on hover
                        },
                      }}
                    >
                      {activeThumb === "dislike" ? (
                        <ThumbDownIcon sx={{ fontSize: "24px" }} /> // Filled thumbs down when clicked
                      ) : (
                        <ThumbDownOutlinedIcon sx={{ fontSize: "24px" }} /> // Outlined thumbs down by default
                      )}
                    </Box>
                  </Tooltip>
                  <CommonCopy contentToCopy={processedpojoClassData} />

                </Box>
              </Box>
            </Container>
          </Box>
        }
        buttons={[
       
          {
            label: "Download",
            onClick: handleDownloadClick,
            variant: "text",
            startIcon: <SaveAltRoundedIcon />,
            sx: { textTransform: "none" },
          },

             ...nextButton
          // {
          //   label: "Generate Step Definition",
          //   onClick: handleStepDefinition,
          //   variant: "contained",
          //   startIcon: <GenerateButtonIcon />,
          //   sx: { textTransform: "none", float: "right" },
          // },
        ]}
        type={"output"}
        fullScreenMode={true}
        defaultExpanded={defaultExpand}
      />

      <CommonDownload
        open={downloadOpen}
        onClose={handleCloseDownload}
        serviceResponse={[
          { heading: "POJO Classes", type: "text", data: processedpojoClassData },
        ]}
        serviceName="POJO Classes"
        wordData={[
          { heading: "POJO Classes", type: "text", data: processedpojoClassData },
        ]}
        documents={["docx", "pdf"]}
      />
    </Box>
  );
};

export default POJOclasses;
